import axios from 'axios';


const CHECK_PRINT_INTERVAL = 3000;
const MAX_PRINT_INTERVAL = 15*60*1000; // 15 minutos máximo de espera

const handlePrintStudy = async (
  accountId, patientName, printCanceled, printStudyLink,
  printTotalTime, setPrintBuffer, setPrintStatus, studyId, user
) => {
  try {
    setPrintStatus('printing');

    printCanceled.current = false;
    const { downloadUrl } = await axios
      .get(printStudyLink)
      .then((res) => res.data)
      .catch(e => setPrintStatus(e.toString()));

    const printUrl = decodeURI(downloadUrl);
    printTotalTime.current = 0;

    setTimeout(checkPrint, CHECK_PRINT_INTERVAL);

    // Vou ficar esperando até o PDF ser criado no S3
    async function checkPrint() {
      const result = await axios
        .get(printUrl, { responseType: 'arraybuffer' })
        .then(res => new Blob([new Uint8Array(res.data)]))
        .catch(e => {
          printTotalTime.current += CHECK_PRINT_INTERVAL;
          // Se deu 404 continuo esperando, a menos que já ultrapassou o tempo máximo de espera
          if (e?.response?.status !== 404 || printTotalTime.current > MAX_PRINT_INTERVAL) {
            setPrintStatus(e.toString());
            printCanceled.current = true;
          } else {
            if (printCanceled.current === false) {
              setTimeout(checkPrint, CHECK_PRINT_INTERVAL);
            }
          }
        });
      if (!!result && printCanceled.current === false) {
        setPrintBuffer(result);

        axios.post('/external/insertResultsPortalLogs', {
          type: 'resultsPortal',
          subType: 'printStudy',
          studyId,
          patientName,
          accountId,
          user: {
            username: user.username,
            typeUser: user.type === 'medico'
              ? 'Médico solicitante'
              : user.type === 'paciente' ? 'Paciente' : 'Prestador'
          }
        }).then(() => {}).catch((err) => { console.error(err); });
      }
    }
  } catch(e) {
    console.log('Error printing zip: ', e.toString());
    setPrintStatus(e.toString());
  }
}

export default handlePrintStudy;